import { jsxs, jsx } from 'react/jsx-runtime';
import { Tooltip, Tag, Text } from '@flex-design-system/fx';
import { StaroflifeIcon } from '@flex-design-system/legacy-flex-icons';
import { styled } from '@flex-design-system/stitches-react';
import { isEllipsisActive } from '@flex-design-system/utils-style';
import { useTranslation } from '@flex-mf/i18n';
import { useRef } from 'react';

function PositionTag({ position }) {
  const ref = useRef(null);
  const { isPrimary, isHeadUser, jobTitleName, departmentName } = position;
  const { t } = useTranslation();
  const textContent = [
    departmentName,
    isHeadUser ? t("@flex-services/user-avatar.domains.core-user.\uC870\uC9C1\uC7A5") : void 0,
    jobTitleName
  ].filter(Boolean).join(" \xB7 ").trim();
  const leftSlot = isPrimary ? /* @__PURE__ */ jsx(StaroflifeIcon, { type: "fill", size: 14, color: "purpleLight" }) : null;
  const contentTruncated = ref.current != null ? isEllipsisActive(ref.current, 2) : false;
  const tagContent = /* @__PURE__ */ jsx(
    StyledTag,
    {
      leftSlot,
      contentTruncated,
      isPrimary,
      variant: "outline",
      size: "large",
      children: /* @__PURE__ */ jsx(
        Text,
        {
          ellipsis: true,
          weight: 600,
          ref,
          color: "gray",
          id: `text-${departmentName}`,
          children: textContent
        }
      )
    }
  );
  return contentTruncated ? /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { children: tagContent }),
    /* @__PURE__ */ jsx(Tooltip.Content, { side: "bottom", children: textContent })
  ] }) : tagContent;
}
const TooltipTrigger = styled(Tooltip.Trigger, {
  all: "unset"
});
const StyledTag = styled(Tag, {
  variants: {
    contentTruncated: {
      true: {
        "&:hover": {
          backgroundColor: "$blackAlpha003"
        }
      }
    },
    isPrimary: {
      true: {
        paddingLeft: 5
      }
    }
  }
});

export { PositionTag as default };
//# sourceMappingURL=PositionTag.mjs.map
